var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#4D9A9A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 20.6C29 21.3426 28.705 22.0548 28.1799 22.5799C27.6548 23.105 26.9426 23.4 26.2 23.4H9.4C7.846 23.4 6.6 22.14 6.6 20.6V3.8C6.6 2.246 7.846 1 9.4 1H26.2C26.9426 1 27.6548 1.295 28.1799 1.8201C28.705 2.3452 29 3.05739 29 3.8V20.6ZM20.6 26.2V29H3.8C3.05739 29 2.3452 28.705 1.8201 28.1799C1.295 27.6548 1 26.9426 1 26.2V8H3.8V26.2H20.6ZM16.4 17.8L26.2 8L24.226 6.026L16.4 13.838L12.074 9.526L10.1 11.5L16.4 17.8Z",
    fill: "#377E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.cf48f78eabbed4aa7fd6433cbc2912db.svg";
export { ForwardRef as ReactComponent };